// Check support status at:
// https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariCSSRef/Articles/StandardCSSProperties.html
/** CSS `@supports` query matching iOS/iPadOS WebKit browsers. */
export const iOS = '@supports (-webkit-touch-callout: none)';